export enum Routes {
  Survey = '/survey/:surveyId',
  Referrer = '/referral/referrer',
  Referee = '/referral/referee',
  Wheel = '/wheel'
}
